/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// import { Attributes } from '@leverege/ui-attributes'
import { ValueCache } from '@leverege/value-cache';
import { Flex, Text, Button, Content } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { connect } from 'react-redux';
import { UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import FileUtil from "./file/Util.js";
import Uploader from "./file/Uploader.js";
import Util from "./Utils.js";
import S from './CreateEditForm.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  sort,
  defaultGetAttributes,
  bulkCreateAttributeFilter
} = Util;
const {
  t,
  tIcon
} = I18N.ns('molten.imagine.forms.BulkCreateUploadForm');
class BulkCreateUpload extends React.Component {
  static propTypes = {
    getAttributes: PropTypes.func,
    contentVariant: PropTypes.string,
    contentHeaderVariant: PropTypes.string,
    contentAreaVariant: PropTypes.string,
    contentFooterVariant: PropTypes.string,
    titleVariant: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    titleIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleVariant: PropTypes.string,
    bodyVariant: PropTypes.string,
    downloadVariant: PropTypes.string,
    downloadIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    eventData: PropTypes.any,
    nextText: PropTypes.string,
    cancelText: PropTypes.string,
    loading: PropTypes.bool
  };
  static defaultProps = {
    getAttributes: defaultGetAttributes,
    contentVariant: 'default',
    contentHeaderVariant: 'formHeader',
    contentAreaVariant: 'formBody',
    contentFooterVariant: 'formButtons',
    titleVariant: 'dialogTitle',
    get title() {
      return t('title');
    },
    get titleIcon() {
      return tIcon('titleIcon', 'fa fa-plus fa-fw');
    },
    subtitleVariant: 'dialogTitle',
    bodyVariant: 'dialogBody|body',
    downloadVariant: 'tertiary',
    get downloadIcon() {
      return tIcon('downloadIcon', 'fa fa-download');
    },
    eventData: null,
    get nextText() {
      return t('nextText');
    },
    get cancelText() {
      return t('cancelText');
    },
    loading: false
  };
  constructor(props) {
    super(props);
    this.cache = new ValueCache();
    this.state = {
      data: props?.data,
      fileName: props?.fileName
    };
  }
  onSubmit = evt => {
    const {
      onSubmit,
      eventData
    } = this.props;
    const {
      data,
      fileName
    } = this.state;
    if (typeof onSubmit === 'function') {
      onSubmit({
        value: {
          data,
          fileName
        },
        data: eventData,
        original: evt
      });
    }
  };
  onCancel = evt => {
    const {
      onCancel,
      eventData
    } = this.props;
    if (onCancel) onCancel({
      data: eventData,
      original: evt
    });
  };
  getAttributes() {
    const {
      getAttributes,
      target
    } = this.props;
    return this.cache.calc((target, getAttributes) => {
      const attrs = getAttributes(target, bulkCreateAttributeFilter) || [];

      // sort them
      attrs.sort(sort);
      return attrs;
    }, target, getAttributes);
  }
  onCSVSelect = evt => {
    const {
      dispatch
    } = this.props;
    const {
      result,
      fileName
    } = evt.value;
    this.setState({
      data: result,
      fileName
    });
    dispatch(UI.set('uploadedFileName', fileName));
  };
  downloadTemplate = () => {
    const {
      relationship
    } = this.props;
    const attributes = this.getAttributes();
    const columns = attributes.map(attr => {
      return attr.displayName;
    });
    const targetName = relationship.blueprint.name;
    FileUtil.exportFile(columns.join(','), t('fileName', {
      targetName
    }));
  };
  render() {
    const {
      contentVariant,
      contentHeaderVariant,
      contentAreaVariant,
      contentFooterVariant,
      titleVariant,
      title,
      titleIcon,
      subtitleVariant,
      bodyVariant,
      downloadIcon,
      downloadVariant,
      nextText,
      cancelText,
      loading
    } = this.props;
    const {
      fileName,
      data
    } = this.state;
    return /*#__PURE__*/_jsxs(Content, {
      variant: contentVariant,
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: contentHeaderVariant,
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: title,
          icon: titleIcon
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: contentAreaVariant,
        className: S.form,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: subtitleVariant,
            children: t('subtitle')
          }), /*#__PURE__*/_jsx(Text, {
            variant: bodyVariant,
            children: t('body')
          }), /*#__PURE__*/_jsx(Button, {
            icon: downloadIcon,
            onClick: this.downloadTemplate,
            variant: downloadVariant,
            style: {
              width: 250
            },
            children: t('buttonText')
          }), /*#__PURE__*/_jsx(Uploader, {
            onChange: this.onCSVSelect,
            onClose: this.onCancel,
            fileName: fileName
          })]
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        variant: contentFooterVariant,
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          type: "button",
          onClick: this.onCancel,
          children: loading ? /*#__PURE__*/_jsx("i", {
            className: "fa fa-spin fa-spinner"
          }) : cancelText
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !data,
          onClick: this.onSubmit,
          children: loading ? /*#__PURE__*/_jsx("i", {
            className: "fa fa-spin fa-spinner"
          }) : nextText
        })]
      })]
    });
  }
}
export default connect((state, props) => {
  return {};
})(BulkCreateUpload);